<template>
  <div
    class="w-[30px] h-[30px] rounded-full border flex items-center justify-center"
    :class="circleClasses"
  >
    <slot />
  </div>
</template>

<script setup>
import {computed} from "vue";

const props = defineProps({
  active: {
    type: Boolean,
    default: false
  },
  selected: {
    type: Boolean,
    default: false
  }
});

const circleClasses = computed(() => {
  if (props.selected) {
    return 'border-accent bg-base-300 text-primary';
  } else if (props.active) {
    return 'border-accent bg-base-100 text-base-content/60 :hover:border-4 hover:bg-base-300 hover:text-primary hover:ring-2 hover:ring-accent';
  } else {
    return 'border-base-300 bg-base-100 text-base-content/60';
  }
});
</script>